// Wires the optional prev/next buttons of sm-product-carousel to the scroll row.
// Progressive enhancement only: the row already scrolls natively (trackpad, shift+wheel,
// drag) without this. This only adds button-driven paging, disabled/hidden states.
function initCarousel(section) {
  const row = section.querySelector('.sm-product-carousel__row');
  const nav = section.querySelector('.sm-product-carousel__nav');
  const prev = section.querySelector('[data-sm-carousel-prev]');
  const next = section.querySelector('[data-sm-carousel-next]');
  if (!row || !nav || !prev || !next) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function step() {
    const card = row.firstElementChild;
    if (!card) return row.clientWidth;
    const style = window.getComputedStyle(row);
    const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function update() {
    const canScroll = row.scrollWidth - row.clientWidth > 1;
    nav.hidden = !canScroll;
    if (!canScroll) return;
    const atStart = row.scrollLeft <= 1;
    const atEnd = row.scrollLeft >= row.scrollWidth - row.clientWidth - 1;
    prev.disabled = atStart;
    prev.setAttribute('aria-disabled', String(atStart));
    next.disabled = atEnd;
    next.setAttribute('aria-disabled', String(atEnd));
  }

  prev.addEventListener('click', () => {
    row.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
  });
  next.addEventListener('click', () => {
    row.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  row.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
}

document.querySelectorAll('[data-section="sm-product-carousel"]').forEach(initCarousel);
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('[data-section="sm-product-carousel"]');
  if (section) initCarousel(section);
});
